/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const Container = styled.span({
  display: 'inline-flex',
  /* Adds space after nav buttons if there is another div (when not sticky header,
  there's a settings icon button to the right of these nav buttons) */
  '& + div': {
    marginLeft: token('space.100'),
  },
  /* Adds space between the left and right nav buttons  */
  '& > div:first-of-type': {
    marginRight: token('space.050'),
  },
});

export const FileNumber = styled.span({
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtlest'),
  alignSelf: 'center',
  margin: `0 ${token('space.100')}`,
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  textTransform: 'uppercase',
});
